__turbopack_context__.v({
  "agenciesProfilePictures": "HubDestinationDropdownContent-module__fJMiOG__agenciesProfilePictures",
  "agenciesTitleContainer": "HubDestinationDropdownContent-module__fJMiOG__agenciesTitleContainer",
  "arrowCircle": "HubDestinationDropdownContent-module__fJMiOG__arrowCircle",
  "arrowIcon": "HubDestinationDropdownContent-module__fJMiOG__arrowIcon",
  "blockDestination": "HubDestinationDropdownContent-module__fJMiOG__blockDestination",
  "blockDestinationLinksList": "HubDestinationDropdownContent-module__fJMiOG__blockDestinationLinksList",
  "blockDestinationLinksListItem": "HubDestinationDropdownContent-module__fJMiOG__blockDestinationLinksListItem",
  "blockDivider": "HubDestinationDropdownContent-module__fJMiOG__blockDivider",
  "blockFacets": "HubDestinationDropdownContent-module__fJMiOG__blockFacets",
  "blockRegions": "HubDestinationDropdownContent-module__fJMiOG__blockRegions",
  "blockTitle": "HubDestinationDropdownContent-module__fJMiOG__blockTitle",
  "container": "HubDestinationDropdownContent-module__fJMiOG__container",
  "destinationButton": "HubDestinationDropdownContent-module__fJMiOG__destinationButton",
  "destinationHighlightCard": "HubDestinationDropdownContent-module__fJMiOG__destinationHighlightCard",
  "destinationHighlightCardImage": "HubDestinationDropdownContent-module__fJMiOG__destinationHighlightCardImage",
  "destinationHighlightCardText": "HubDestinationDropdownContent-module__fJMiOG__destinationHighlightCardText",
  "facetCard": "HubDestinationDropdownContent-module__fJMiOG__facetCard",
  "facetsContainer": "HubDestinationDropdownContent-module__fJMiOG__facetsContainer",
  "hasItineraries": "HubDestinationDropdownContent-module__fJMiOG__hasItineraries",
  "main": "HubDestinationDropdownContent-module__fJMiOG__main",
  "navButtonRegionLinkContainer": "HubDestinationDropdownContent-module__fJMiOG__navButtonRegionLinkContainer",
  "separator": "HubDestinationDropdownContent-module__fJMiOG__separator",
  "side": "HubDestinationDropdownContent-module__fJMiOG__side",
});
